module.exports = __webpack_public_path__ + "img/icon-remove.71e43e8c.svg";